"use strict";

import { defineSimpleTerm, _I_ } from 'components/locs';
import MoneyUtil from 'components/moneyUtil';
import { ordersSummary } from 'components/orderAssets';
import { walletLimits } from 'components/walletLimitsController';
import { dataBound } from 'generics/dataBound';
import { IconFontAwesome } from 'generics/icons';
import React from 'react';



class WalletLimitsIcon extends React.Component  {
  constructor(props)  {
    super(props);
    const {  market  } = SettingsInjections.getUsedCurrency();
    this.market = market;
  }


  checkNotes()  {
    const  {  balance,  orders,  } = this.props;

    const current = [
        (balance[this.market]||0),  (orders.sellOrdersTotal||0),  (orders.buyOrdersTotal||0),
      ].reduce(
        ( accum, val )  => (accum + (+MoneyUtil.formatMoney(val))),
        0
      )

    const {  soft_limit,  hard_limit,  } = this.props.wlimits;
    const { isWealthyUser }  =  SettingsInjections.getCredentials();

    if ( !isWealthyUser && hard_limit && (current >= hard_limit) )
      return {  type:"exclamation-circle",  className:"text-danger",
                title:_I_("WalletLimitsIcon.hard_limit")  };

    if ( !isWealthyUser && soft_limit && (current >= soft_limit) )
      return {  type:"exclamation-triangle",  className:"text-warning",
                title:_I_("WalletLimitsIcon.soft_limit") };
  }


  render()  {
    const notes = this.checkNotes();
    return  <i id="balance" className={notes && notes.className}>
              {notes && <IconFontAwesome type={notes.type} fixedWidth  title={notes.title} />}
              <img className="iconGjn" src="images/gjn_coin.png" />
            </i>;
  }
}


export default dataBound(WalletLimitsIcon, {
  "wlimits":walletLimits,
  "orders":ordersSummary,
});


defineSimpleTerm( "WalletLimitsIcon.soft_limit",  "GJN coins limit exceeded.\nReplenish functions are limited.",       {
  "ru_RU": "Превышен лимит GJN, функции пополнения недоступны",
  "cs_CZ": "GJN coins limit exceeded.\nReplenish functions are limited.",
  "fr_FR": "Limite de GJN coins dépassée.\nLa fonction de réapprovisionnement est limitée.",
  "de_DE": "Beschränkung der GJN-Coins überschritten.\nDie Auffüllfunktionen sind beschränkt.",
  "it_IT": "Limite GJN coins oltrepassato.\nFunzioni di rifornimento limitate.",
  "ko_KR": "가이진 코인 소유 제한을 넘어섰습니다.\n코인 충전 기능을 이용하실 수 없습니다.",
  "pl_PL": "Limit GJN Coins przekroczony.\nFunkcje odnawiania są ograniczone.",
  "pt_PT": "GJN coins limit exceeded.\nReplenish functions are limited.",
  "es_ES": "Límite de monedas GJN excedido.\nLas funciones de reabastecimiento son limitadas.",
  "zh_CN": "超过 GJN coins 限制。\n补充功能受限。",
  "zh_TW": "超過 GJN coins 限制。\n補充功能受限。"
} );

defineSimpleTerm( "WalletLimitsIcon.hard_limit",  "GJN coins limit exceeded.\nSell and replenish functions are limited.",       {
  "ru_RU": "Превышен лимит GJN, функции продажи и пополнения недоступны",
  "cs_CZ": "GJN coins limit exceeded.\nSell and replenish functions are limited.",
  "fr_FR": "Limite de GJN coins dépassée.\nLes fonctions de réapprovisionnement et de vente sont limitées.",
  "de_DE": "Beschränkung der GJN-Coins überschritten.\nVerkauf und Auffüllfunktionen sind beschränkt.",
  "it_IT": "Limite GJN coins oltrepassato.\nFunzioni di Vendita e rifornimento limitate.",
  "ko_KR": "가이진 코인 소유 제한을 넘어섰습니다.\n판매 및 코인 충전 기능을 이용하실 수 없습니다.",
  "pl_PL": "Limit GJN Coins przekroczony.\nFunkcje sprzedawania i odnawiania są ograniczone.",
  "pt_PT": "GJN coins limit exceeded.\nSell and replenish functions are limited.",
  "es_ES": "Límite de monedas GJN excedido.\nLas funciones de reabastecimiento y venta son limitadas.",
  "zh_CN": "超过 GJN coins 限制。\n出售及补充功能受限。",
  "zh_TW": "超過 GJN coins 限制。\n出售及補充功能受限。"
} );

